import { TableFilterType } from './table-filter-type';

export class TableFilter {
  public propertyName: string;
  public stringValue: string;
  public filterType: TableFilterType = TableFilterType.String;
}
